import { render, staticRenderFns } from "./notPermission.vue?vue&type=template&id=37c90f0e&scoped=true"
import script from "./notPermission.vue?vue&type=script&lang=js"
export * from "./notPermission.vue?vue&type=script&lang=js"
import style0 from "./notPermission.vue?vue&type=style&index=0&id=37c90f0e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c90f0e",
  null
  
)

export default component.exports